export default __webpack_public_path__ + "static/media/KEBAB-BTCB.8cda5e4a.png";